export default "__VITE_ASSET__88744018__"